export default __webpack_public_path__ + "static/media/springrolls.7f58b13f.png";